import { useRef, useState } from "react";

export const useRecorder = () => {
  const [recording, setRecording] = useState(false);
  const rec = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mime = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
    const r = new MediaRecorder(stream, { mimeType: mime });
    chunks.current = [];
    r.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
    r.start();
    rec.current = r;
    setRecording(true);
  };

  const stop = () =>
    new Promise((resolve) => {
      const r = rec.current;
      if (!r) return resolve(null);
      r.onstop = () => {
        r.stream.getTracks().forEach((t) => t.stop());
        setRecording(false);
        const type = r.mimeType || "audio/webm";
        resolve(new File([new Blob(chunks.current, { type })], type.includes("webm") ? "voce.webm" : "voce.m4a", { type }));
      };
      r.stop();
    });

  return { recording, start, stop };
};

export const speak = (text) => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "it-IT";
  u.rate = 0.9;
  window.speechSynthesis.speak(u);
};
